/**
 * Formats a well's lease + well number the way the map popups show it ("GUNSMOKE
 * #1H"). The single owner of that format, shared by the General well popup and the
 * Eval 3 scoped-slot popup (INS-14081).
 *
 * @param {string | null} leaseName - The lease name, or null.
 * @param {string | null} wellNumber - The well number, or null.
 * @return {string | null} "<lease> #<well>" when both are present, otherwise whichever
 *   one is present, or null when neither is. Callers that must render something supply
 *   their own empty fallback (e.g. `?? EMPTY_CELL`).
 */
export function formatLeaseAndWell(
  leaseName: string | null,
  wellNumber: string | null
): string | null {
  const lease = leaseName || '';
  const well = wellNumber || '';
  if (lease && well) {
    return `${lease} #${well}`;
  }
  return lease || well || null;
}
